/**
 * Legacy-Redirect: /commissions/create → /splits/create — Story 0.2
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/commissions/create')({
  beforeLoad: () => {
    throw redirect({ to: '/splits/create', replace: true })
  },
  component: () => null,
})
